/**
 * Drive folder browse is one Google OAuth token at a time (per workspace).
 * The global PIP is still the source of which workspaces are in scope;
 * this helper only decides when a Drive-local focus picker is needed.
 */

export function resolveDriveFocusCandidates(
  activeWorkspaceIds: string[],
  workspaces: Array<{ id: string }>,
): string[] {
  const known = new Set(workspaces.map((workspace) => workspace.id))
  return activeWorkspaceIds.filter((id) => known.has(id))
}

export function clampDriveFocusWorkspaceId(
  current: string,
  candidates: string[],
): string {
  if (current && candidates.includes(current)) return current
  return candidates[0] ?? ''
}

export function shouldShowDriveFocusPicker(candidates: string[]): boolean {
  return candidates.length > 1
}

/** Stamp the Drive index tab with the workspace of the selected Drive account. */
export function bindDriveIndexTabToWorkspace<
  T extends {
    type?: string
    workspaceId?: string | null
    integrationData?: Record<string, unknown>
  },
>(tabs: T[], workspaceId: string): T[] {
  if (!workspaceId) return tabs
  return tabs.map((tab) => {
    if (tab.type !== 'integration-google-drive') return tab
    if (
      tab.workspaceId === workspaceId &&
      tab.integrationData?.organizationId === workspaceId
    ) {
      return tab
    }
    return {
      ...tab,
      workspaceId,
      integrationData: {
        ...(tab.integrationData ?? {}),
        integrationId: 'google-drive',
        organizationId: workspaceId,
      },
    }
  })
}
